export default __webpack_public_path__ + "static/media/icon_comment_open_24_Regular_green.9cde301c.svg";